import { svg } from 'lit';

export const wafIcon = svg`
  <path fill-rule="evenodd" clip-rule="evenodd" d="M2 6C2 4.89543 2.89543 4 4 4H20C21.1046 4 22 4.89543 22 6V18C22 19.1046 21.1046 20 20 20H4C2.89543 20 2 19.1046 2 18V6ZM8 6H4V11H8V6ZM10 6V11H20V6H10ZM20 13H14V18H20V13ZM12 18V13H4V18H12Z" fill="currentColor"/>
  `;
